import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { displayUsedPrice } from "@/lib/price";
import ReliabilityBadge from "@/components/results/ReliabilityBadge";

export const ResultsHeader = ({ result, input, photoPreviews }) => {
  const { t } = useLang();

  return (
    <div className="lg:col-span-12 grid grid-cols-1 md:grid-cols-12 gap-0 border border-black bg-white">
      <div className="md:col-span-7 p-8 md:p-12 border-r-0 md:border-r border-b md:border-b-0 border-black">
        <span className="overline text-[#002FA7]">RESULT / ESTIMATE</span>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-2">{t.results.title}</h1>
        <div className="mt-8">
          <div className="overline text-[#737373]">{t.results.market_value}</div>
          <div data-testid="market-value" className="font-display font-black text-5xl sm:text-7xl lg:text-8xl tracking-tighter leading-none mt-2">
            €{displayUsedPrice(result.estimated_market_value)}
          </div>
        </div>
      </div>
      <div className="md:col-span-5 p-8 md:p-12 bg-[#0A0A0A] text-white">
        <span className="overline text-[#FFCC00]">AI ANALYSIS</span>
        <p className="mt-4 text-[#E5E5E5] leading-relaxed">{result.reasoning}</p>
        {photoPreviews && photoPreviews.length > 0 && (
          <div data-testid="result-photos" className="mt-6">
            <span className="overline text-[#737373]">{t.results.photos_label}</span>
            <div className="flex gap-2 mt-2">
              {photoPreviews.map((p, i) => (
                <img key={p} src={p} alt={`photo-${i}`} className="w-16 h-16 object-cover border border-white/20" />
              ))}
            </div>
          </div>
        )}
        <div className="mt-8 flex items-center justify-between">
          <span className="overline text-[#737373]">{t.results.confidence}</span>
          <span data-testid="confidence" className="font-display font-black tracking-tight text-xl">
            {t.results.conf[result.confidence] || result.confidence}
          </span>
        </div>
        <div className="mt-6 pt-6 border-t border-white/15">
          <ReliabilityBadge input={input} dark />
        </div>
      </div>
    </div>
  );
};

export default ResultsHeader;
